import { staffProviderHealthSchema } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
export function createStaffProviderHealthApi(options) {
    const send = createMemoryTransport(options);
    return {
        getProviderHealth: (callOptions) => send({
            method: "GET",
            path: "/staff/operations/provider-health",
            schema: staffProviderHealthSchema,
            signal: callOptions?.signal,
        }),
    };
}
